export default "__VITE_ASSET__fb41cf3a__"